<template>
  <div class="vx-row">
    <div v-show="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <!-- <vx-card> -->
    <div v-show="!loading" class="w-full">
      <div slot="no-body" class="tabs-container inventory_tabSec" id="view-customer-tab">
        <vx-card>
          <vs-table
            :max-items="paginationItems[1]"
            pagination
            :data="billCycleList || []"
            :description="false"
            search
            :description-items="paginationItems"
            description-title="Registries"
            description-connector="of"
            description-body="Pages"
          >
            <template slot="header">
              <div class="list-heading">
                {{ $t("billManagement.label.BillingManagement") }}
              </div>
              <div class="mr-2 mb-1 order-1">
                <vs-button
                  icon-pack="feather"
                  icon="icon-plus"
                  @click="onClickGenerateBilling"
                  size="small"
                  >{{ $t("billManagement.label.CreateBillingCycle") }}</vs-button
                >
              </div>
            </template>
            <template slot="thead">
              <vs-th>{{ $t("billManagement.label.BillingDay") }}</vs-th>
              <vs-th>{{ $t("billManagement.label.BillingCycle") }}</vs-th>
              <vs-th>{{ $t("billManagement.label.BDOM") }}</vs-th>
              <vs-th>{{ $t("billManagement.label.LastBillingDate") }}</vs-th>
              <vs-th>{{ $t("billManagement.label.NextBillingDate") }}</vs-th>
              <vs-th>{{ $t("billManagement.label.InterfaceDay") }}</vs-th>
              <vs-th>{{ $t("billManagement.label.CurrentCycleDate") }}</vs-th>
              <vs-th>{{ $t("billManagement.label.NoOfProfileBills") }}</vs-th>
              <vs-th>{{ $t("billManagement.label.Status") }}</vs-th>
              <vs-th>{{ $t("billManagement.label.History") }}</vs-th>
              <vs-th class="tHeadCenter">{{ $t("billManagement.label.Action") }}</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr
                :key="index"
                :data="bill"
                v-for="(bill, index) in data"
                :class="{
                  'highlighted-row': isNextClosestBillingDay(bill.billingDayOfMonth),
                }"
              >
                <vs-td>{{ bill.billCycleName }}</vs-td>
                <vs-td>{{ bill.billingFrequency }}</vs-td>
                <vs-td>{{ bill.billingDayOfMonth }}</vs-td>
                <vs-td>{{ getDate(bill.lastBillingDate) }}</vs-td>
                <vs-td>{{ getDate(bill.nextBillingDate) }}</vs-td>
                <vs-td>{{ bill.interfaceDay }}</vs-td>
                <vs-td>{{ getDate(bill.currentCycleStartDate) }}</vs-td>
                <vs-td>{{ getCustomerCount(bill.id) }}</vs-td>
                <vs-td
                  ><span :style="{ color: statusColor(bill.status) }">
                    {{ bill.status.toUpperCase() }}
                  </span></vs-td
                >
                <vs-td class="whitespace-no-wrap">
                  <div class="container_img">
                    <feather-icon
                      icon="ClockIcon"
                      title="History"
                      svgClasses="w-5 h-5 text-warning stroke-current cursor orange_icon"
                      @click.stop="viewHistory(bill.billingDayOfMonth)"
                      class="icon_row"
                    />
                  </div>
                </vs-td>
                <vs-td class="whitespace-no-wrap">
                  <div class="container_img">
                    <!-- <feather-icon
                      icon="EditIcon"
                      title="edit"
                      svgClasses="w-5 h-5 text-warning stroke-current cursor orange_icon"
                      @click.stop="editHistory(bill.id)"
                      class="icon_row"
                    /> -->
                    <vs-dropdown
                      vs-custom-content
                      vs-trigger-click
                      class="cursor-pointer"
                    >
                      <div class="con-img">
                        <feather-icon
                          title="More"
                          icon="MoreHorizontalIcon"
                          svgClasses="w-5 h-5 hover:text-danger stroke-current"
                          class="ml-2 icon_row"
                        />
                      </div>
                      <vs-dropdown-menu class="vx-navbar-dropdown">
                        <ul style="min-width: 13rem">
                          <li
                            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                          >
                            <feather-icon icon="FileTextIcon" svgClasses="w-4 h-4" />
                            <span class="ml-2" @click="handleTrialBilling(bill)">{{
                              $t("billManagement.label.trialBilling")
                            }}</span>
                          </li>
                          <li
                            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                          >
                            <feather-icon icon="FileTextIcon" svgClasses="w-4 h-4" />
                            <span class="ml-2" @click="handleBilling(bill)">{{
                              $t("billManagement.label.billing")
                            }}</span>
                          </li>
                        </ul>
                      </vs-dropdown-menu>
                    </vs-dropdown>
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>
    </div>
    <!-- </vx-card> -->
    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="$t('billManagement.label.CreateBillingCycle')"
        :active.sync="generateBillingPopup"
        class="popup-close"
      >
        <ValidationObserver ref="observer">
          <form>
            <div class="vx-row md:w-full lg:w-full sm:w-full mb-2">
              <div class="vx-col sm:w-full md:w-1/2">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('billManagement.label.BillingCycleName')"
                >
                  <vs-input
                    :label="$t('billManagement.label.BillingCycleName')"
                    type="text"
                    v-model="billCycleName"
                    class="w-full mb-2 font-semibold starlabel"
                  />
                  <span class="validate-error" style="color: red">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col sm:w-full md:w-1/2">
                <div class="dropdown-with-label">
                  <small class="date-label font-semibold"
                    >{{ $t("billManagement.label.BillingFrequency") }}
                    <span class="required">*</span></small
                  >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('billManagement.label.BillingFrequency')"
                  >
                    <v-select
                      label="text"
                      :options="['Monthly']"
                      v-model="billFrequency"
                      :placeholder="$t('placeholder.label.SelectOne')"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="min-w-200 w-full mb-2"
                    >
                    </v-select>
                    <span class="validate-error" style="color: red">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>
            </div>
            <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
              <div class="vx-col sm:w-full md:w-1/2">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('billManagement.label.BillingDayOfMonth')"
                >
                  <vs-input
                    :label="$t('billManagement.label.BillingDayOfMonth')"
                    type="text"
                    v-model="billingDayOfMonth"
                    class="w-full mb-2 font-semibold starlabel"
                  />
                  <span class="validate-error" style="color: red">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col sm:w-full md:w-1/2">
                <div class="dropdown-with-label">
                  <small class="date-label font-semibold"
                    >{{ $t("billManagement.label.Status")
                    }}<span class="required">*</span></small
                  >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('billManagement.label.Status')"
                  >
                    <v-select
                      label="text"
                      :options="['Active', 'Inactive']"
                      v-model="status"
                      :placeholder="$t('placeholder.label.SelectOne')"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="min-w-200 w-full mb-2"
                    >
                    </v-select>
                    <span class="validate-error" style="color: red">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>
            </div>
            <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
              <div class="vx-col sm:w-full md:w-1/2">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('billManagement.label.InterfaceDay')"
                >
                  <vs-input
                    :label="$t('billManagement.label.InterfaceDay')"
                    type="text"
                    v-model="interfaceDay"
                    class="w-full mb-2 font-semibold starlabel"
                  />
                  <span class="validate-error" style="color: red">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-row">
              <span class="ml-4 mr-1">
                <vs-button
                  style="margin-left: 220px"
                  type="border"
                  @click="generateBillingPopup = false"
                  >{{ $t("billManagement.label.Cancel") }}</vs-button
                >
              </span>
              <span class="ml-1 mr-2">
                <vs-button @click="onSubmitGenerateBilling">{{
                  $t("billManagement.label.Confirm")
                }}</vs-button>
              </span>
            </div>
          </form>
        </ValidationObserver>
      </vs-popup>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { AtomSpinner } from "epic-spinners";
import vSelect from "vue-select";
import moment from "moment";
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  data() {
    return {
      loading: false,
      generateBillingPopup: false,
      paginationItems: [5, 10, 15],
      billCycleName: "",
      billFrequency: "",
      billingDayOfMonth: null,
      interfaceDay: null,
      status: "",
    };
  },
  components: {
    AtomSpinner,
    ValidationProvider,
    ValidationObserver,
    "v-select": vSelect,
  },
  computed: {
    ...mapState({
      formattedDate: (state) => state.settings.selectedDateFormat,
      noOfBillProfiles: (state) => state.billManagement.noOfBillProfiles,
      billCycleList: (state) => state.billManagement.billCycleList,
    }),
  },
  methods: {
    getDate(date) {
      if (date) {
        const d = new Date(date);
        return moment(d).format(this.formattedDate);
      }
    },
    statusColor(status) {
      let color = "";
      switch (status.toUpperCase()) {
        case "ACTIVE":
          color = "blue";
          break;
        case "INACTIVE":
          color = "red";
          break;
        default:
          color = "black";
      }
      return color;
    },
    async getBillCycleMethod() {
      try {
        await this.$store.dispatch("billManagement/getBillCycleAction");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getNoOfBillProfilesMethod() {
      try {
        await this.$store.dispatch("billManagement/getNoOfBillProfilesAction");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    getCustomerCount(billId) {
      const profile = this.noOfBillProfiles.find((p) => p.billcycleid === billId);
      return profile ? profile.customerCount : 0;
    },
    isNextClosestBillingDay(billingDayOfMonth) {
      if (!billingDayOfMonth) return false;

      const today = moment().date();

      const upcomingDays = this.billCycleList
        .map((bill) => parseInt(bill.billingDayOfMonth))
        .filter((day) => day >= today)
        .sort((a, b) => a - b);

      if (upcomingDays.length === 0) {
        const nextMonthDays = this.billCycleList
          .map((bill) => parseInt(bill.billingDayOfMonth))
          .sort((a, b) => a - b);
        return nextMonthDays.length && billingDayOfMonth === nextMonthDays[0];
      }

      return billingDayOfMonth === upcomingDays[0];
    },
    async onClickGenerateBilling() {
      this.billCycleName = "";
      this.billFrequency = "";
      this.billingDayOfMonth = null;
      this.interfaceDay = null;
      this.status = "";
      this.$refs.observer.reset();
      this.generateBillingPopup = true;
    },
    async onSubmitGenerateBilling() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      const payload = {
        billCycleName: this.billCycleName,
        billingFrequency: this.billFrequency,
        billingDayOfMonth: Number(this.billingDayOfMonth),
        interfaceDay: Number(this.interfaceDay),
        status: this.status,
      };
      try {
        await this.$store.dispatch("billManagement/createBillCycleAction", payload);
        this.generateBillingPopup = false;
        this.getBillCycleMethod();
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Billing Cycle Created Successfully!",
          type: "success",
        });
      } catch (error) {
        this.generateBillingPopup = false;
        const errorMessage = String(error).replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
      }
    },
    viewHistory(id) {
      this.$router.push({
        name: "History",
        params: { id: id },
      });
    },
    editHistory() {
      // this.$router.push({ name: "Edit IC Zone", params: { id: id } });
    },
    //   handleSelected3(bill) {
    //     this.$router.push({
    //       name: "View IC Zone",
    //       params: { id: bill.id },
    //     });
    //   },
    handleTrialBilling(bill) {
      this.$router.push({
        name: "Trial Billing",
        params: { id: bill.billCycleName, data: bill },
      });
    },
    handleBilling(bill) {
      this.$router.push({
        name: "Billing",
        params: { id: bill.billCycleName },
      });
    },
  },
  async mounted() {
    this.loading = true;
    await this.getBillCycleMethod();
    await this.getNoOfBillProfilesMethod();
    this.loading = false;
  },
};
</script>
<style scoped>
.highlighted-row {
  background-color: #baffd4 !important;
  color: #000 !important;
}
</style>
